<template>
	<div :id="id" :class="['carousel-block', sectionBackground]">
		<div class="carousel-block__title" v-if="sectionTitle">
			{{ sectionTitle }}
		</div>
		<div class="carousel-block__content">
			<DefaultCarousel v-if="items && items.length > 1">
				<CarouselBlockItem
					v-for="b in items"
					:key="b.id"
					:fields="b.fields"
					class="swiper-slide"
				></CarouselBlockItem>
			</DefaultCarousel>
			<CarouselBlockItem
				v-else-if="items && items.length === 1"
				:key="items[0].id"
				:fields="items[0].fields"
				class="swiper-slide"
			></CarouselBlockItem>
		</div>
	</div>
</template>

<script setup>
const props = defineProps({
	fields: { type: Object, required: true },
	rendering: { type: Object, required: false },
});

const items = computed(() => props.fields?.items);
const sectionTitle = computed(() => props.fields?.sectionTitle?.value);
const sectionBackground = computed(() => props.fields?.cardColor?.value);
const id = computed(() => props.fields?.id?.value);
</script>

<style lang="scss">
.carousel-block {
	scroll-margin-top: calc(var(--header-height, 54px) + var(--spacing-2, 16px));
	margin-top: var(--spacing-3, 24px);
	margin-bottom: var(--spacing-3, 24px);
	padding: var(--spacing-7, 56px) 0;
	border-radius: 30px 30px 0 0;

	.carousel-block__title {
		padding: var(--spacing-2, 16px) var(--spacing-2, 16px) 0
			var(--spacing-2, 16px);
		font-size: var(--text-3xl, 40px);
		font-weight: 900;
		line-height: 120%;
		text-transform: uppercase;
	}

	&,
	&.default,
	&.primary {
		background-color: var(--primary-color, #000);
		color: var(--color-white, #fff);

		.swiper-pagination-bullet {
			background-color: var(--secondary-color, #000);
		}

		.swiper-pagination-bullet-active {
			background-color: var(--color-white, #fff);
		}

		.swiper-button-next,
		.swiper-button-prev {
			svg path:nth-child(1) {
				fill: var(--color-white, #fff);
			}
			svg path:nth-child(2) {
				stroke: var(--color-white, #fff);
			}
		}
	}

	&.secondary {
		background-color: var(--secondary-color, #000);
		color: var(--color-white, #fff);

		.swiper-pagination-bullet {
			background-color: var(--primary-color, #000);
		}

		.swiper-pagination-bullet-active {
			background-color: var(--color-white, #fff);
		}
	}

	&.tertiary {
		background-color: var(--tertiary-color, #000);
		color: var(--color-white, #fff);

		.swiper-pagination-bullet {
			background-color: var(--primary-color, #000);
		}

		.swiper-pagination-bullet-active {
			background-color: var(--color-white, #fff);
		}
	}

	&.grey {
		background-color: var(--color-grey, #282828);
		color: var(--color-white, #fff);

		.swiper-pagination-bullet {
			background-color: var(--color-light-grey, #000);
		}

		.swiper-pagination-bullet-active {
			background-color: var(--color-white, #fff);
		}
	}

	.default-carousel__navigation {
		position: relative;
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 0 var(--spacing-2, 16px);
		margin: var(--spacing-3, 24px) 0 var(--spacing-2, 16px) 0;
		height: 32px;
	}

	.swiper-pagination,
	.swiper-button-container {
		position: relative;
		display: flex;
		align-items: center;
		top: 0;
		bottom: 0;
		right: 0;
		left: 0;
	}

	.swiper-pagination {
		justify-content: flex-start;
	}

	.swiper-button-container {
		gap: var(--spacing-2, 16px);
		justify-content: flex-end;
		height: 32px;
	}

	.swiper-button-next,
	.swiper-button-prev {
		position: relative;
		display: flex;
		align-items: center;
		justify-content: center;
		margin: 0;
		top: 0;
		bottom: 0;
		right: 0;
		left: 0;
		width: 32px;
		height: 32px;

		&:after,
		&:before {
			display: none;
		}
	}

	.swiper-button-prev {
		svg {
			transform: rotate(180deg);
		}
	}
}
</style>
